import { useReactFlow } from '@xyflow/react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useZoomToFit } from '../useZoomToFit';

export function useZoomShortcuts() {
  const { zoomIn, zoomOut, zoomTo } = useReactFlow();
  const { zoomToFit } = useZoomToFit();

  useHotkeys(
    'meta+=,ctrl+=,meta+shift+=,ctrl+shift+=',
    () => zoomIn(),
    {
      preventDefault: true,
    },
    [zoomIn],
  );

  useHotkeys(
    'meta+minus,ctrl+minus,meta+shift+minus,ctrl+shift+minus',
    () => zoomOut(),
    {
      preventDefault: true,
    },
    [zoomOut],
  );

  useHotkeys(
    'meta+0,ctrl+0',
    () => zoomTo(1),
    {
      preventDefault: true,
    },
    [zoomTo],
  );

  useHotkeys(
    'shift+1',
    () => zoomToFit(),
    {
      preventDefault: true,
    },
    [zoomToFit],
  );
}
